import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { inmobiusJobBaseUrl, inmobiusJobApiVersion } = CONFIG_VARS;

export const omrUploadApi = createApi({
  reducerPath: "omrUploadApi",
  baseQuery: createBaseQuery(inmobiusJobBaseUrl["1"], true),
  tagTypes: ["OmrUploads"],
  endpoints: (builder) => ({
    listOmrUploads: builder.query({
      query: ({ schoolId, eventId, gradeId, page, limit }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/omr-uploads/list?page=${page}&limit=${limit}`,
        method: "POST",
        body: {
          school_id: schoolId,
          event_id: eventId,
          ...(gradeId !== undefined && gradeId !== null && gradeId !== ""
            ? { grade_id: gradeId }
            : {}),
        },
      }),
      transformResponse: (response) => ({
        statusCode: response?.status_code,
        status: response?.status,
        message: response?.message,
        totalCount: response?.total_count,
        uploads: Array.isArray(response?.data) ? response.data : [],
      }),
      providesTags: (result) => {
        if (!result?.uploads) {
          return [{ type: "OmrUploads", id: "LIST" }];
        }
        return [
          ...result.uploads.map((upload) => ({
            type: "OmrUploads",
            id: upload?.job_id,
          })),
          { type: "OmrUploads", id: "LIST" },
        ];
      },
    }),
    uploadOmrPdf: builder.mutation({
      query: ({ formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/upload-omr`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "OmrUploads", id: "LIST" }],
    }),
    deleteOmrUpload: builder.mutation({
      query: ({ jobId }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/omr-uploads/${jobId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { jobId }) => [
        { type: "OmrUploads", id: jobId },
        { type: "OmrUploads", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useListOmrUploadsQuery,
  useUploadOmrPdfMutation,
  useDeleteOmrUploadMutation,
} = omrUploadApi;
